/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import useFetchAnalysisList from '../hooks/useFetchAnalysisList';
import { Checkbox, Loading, Text } from '@sede-enterprise/shell-ds-react-framework';
import DataTable from '../../../components/DataTable/DataTable';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { DE_INSTALL_HELP, DE_INSTALLED_PROD_UNIT } from '../../../util/helperTexts';
import useAnalysisData from '../hooks/useAnalysisData';
import { handleAdd, handleClear } from '../util/analysisDataListUtils';

import * as R from "rambda";

const INIT_ORDER = "conditionMonitoringLocation";
const INIT_ORDER_DIRECTION = 1;


const AnalysisDataList = ({ setFeatureOptionsEverywhere, filter, INIT_PAGE, currentPage, handleCurrentPageChange, subjects, subjectIndex, updateSubjects, updateSubjectsIndex }) => {

    const [analysisOrder, setAnalysisOrder] = useState(sessionStorage.getItem("analysisOrder") || INIT_ORDER);
    const [orderDirection, setOrderDirection] = useState(+sessionStorage.getItem("analysisOrderDirection") || INIT_ORDER_DIRECTION);

    const handleOrderChange = (sortBy, direction) => {
        setAnalysisOrder(sortBy);
        sessionStorage.setItem('analysisOrder', sortBy);

        setOrderDirection(+direction);
        sessionStorage.setItem('analysisOrderDirection', +direction);
    }

    const orderString = orderDirection === 1 ? `DESC` : `ASC`;

    const { data: analysisData, error, loading } = useFetchAnalysisList(filter, 10, currentPage, analysisOrder, orderString);
    // set feature options everywhere
    useAnalysisData(subjects, setFeatureOptionsEverywhere);

    const CorrosionLoopContent = ({ row }) => {
        const isSelected = subjects
            .filter((x) => x.type === "Corrosion Loop")
            .map((s) => s.name)
            .includes(row.corrosionLoop);

        // Determine if any Corrosion Loop is selected
        const isCorrosionLoopSelected = subjects.some((x) => x.type === "Corrosion Loop");

        // Determine if any CML is selected
        const isCmlSelected = subjects.some((x) => x.type === "Condition Monitoring Location");

        // Check if any Sensor is selected
        const isSensorSelected = subjects.some((x) => x.type === "Sensor");

        // Only disable if no Corrosion Loop is selected and a CML is selected || if no Corrosion Loop is selected and a Sensor is selected
        const disableCheckbox = (!isCorrosionLoopSelected && isCmlSelected) || (!isCorrosionLoopSelected && isSensorSelected);
        return (
            <div className='cell-action' id="analysis-data-list-id-1">
                <Checkbox
                    id="analysis-data-list-id-2"
                    checked={isSelected}
                    size='xsmall'
                    disabled={disableCheckbox}
                    onChange={(e) => {
                        if (e.target.checked) {
                            handleAdd({
                                rowId: row.id,
                                corrosionLoopId: row.corrosionLoop,
                                subjects,
                                row: row.corrosionLoop,
                                type: "Corrosion Loop",
                                site: row.siteId,
                                updateSubjectsIndex,
                                updateSubjects,
                                subjectIndex,
                                analysisData
                            })
                        } else {
                            handleClear({
                                subjects,
                                id: row.corrosionLoop,
                                type: "Corrosion Loop",
                                site: row.siteId,
                                updateSubjectsIndex,
                                updateSubjects
                            })
                        }
                    }}
                />

                <Link
                    id="analysis-data-list-id-3"
                    className="link"
                    to={`/cls/${encodeURIComponent(row.corrosionLoop)}/details`}
                >
                    {row.corrosionLoop}
                </Link>
            </div>
        );
    };

    const CMLContent = ({ row }) => {
        // Determine if the row is selected
        const isSelected = subjects
            .filter((x) => x.type === "Condition Monitoring Location")
            .map((s) => s.name)
            .includes(row.cmlId);

        // Check if any Corrosion Loop is selected
        const isCorrosionLoopSelected = subjects.some((x) => x.type === "Corrosion Loop");

        // Check if any CML is selected
        const isCmlSelected = subjects.some((x) => x.type === "Condition Monitoring Location");

        // Check if any Sensor is selected
        const isSensorSelected = subjects.some((x) => x.type === "Sensor");

        // Check if the current CML's CL is selected
        const cmlBelongsToSelectedCl = subjects
            .filter((x) => x.type === "Corrosion Loop")
            .some((cl) => cl.corrosionLoopId === row.corrosionLoop);

        // Disable the checkbox if a CL is selected and the current CML does not belong to any selected CL || if a Sensor is selected and the current CML does not belong to any selected Sensor
        const disableCheckbox = (isCorrosionLoopSelected && !cmlBelongsToSelectedCl) || (isSensorSelected && !isCmlSelected);

        return (
            <div className='cell-action' id="analysis-data-list-id-4">
                <Checkbox
                    id="analysis-data-list-id-5"
                    checked={isSelected}
                    size='xsmall'
                    disabled={disableCheckbox}
                    onChange={(e) => {
                        if (e.target.checked) {

                            handleAdd({
                                rowId: row.id,
                                corrosionLoopId: row.corrosionLoop,
                                subjects,
                                row: row.cmlId,
                                type: "Condition Monitoring Location",
                                site: row.siteId,
                                shortname: `${row.equipment} ${row.cmlName}`,
                                updateSubjectsIndex,
                                updateSubjects,
                                subjectIndex,
                                analysisData
                            })
                        } else {
                            handleClear({
                                subjects,
                                id: row.cmlId,
                                type: "Condition Monitoring Location",
                                site: row.siteId,
                                updateSubjectsIndex,
                                updateSubjects
                            })
                        }
                    }}
                />
                <Link
                    id="analysis-data-list-id-6"
                    className="link"
                    to={`/cmls/${encodeURIComponent(row.cmlId)}/details`}
                >
                    {row.cmlName}
                </Link>
            </div>
        );
    };


    const SensorContent = ({ row }) => {
        const site = row.siteId;
        let isSelected = false;
        let disableCheckbox = false;
        if (site === 'BON') {
            // Determine if the row is selected
            isSelected = subjects
                .filter((x) => x.type === "Sensor")
                .map((s) => s.name)
                .includes(row.id);

            // Check if any CML is selected
            const isCmlSelected = subjects.some((x) => x.type === "Condition Monitoring Location");
            // Check if the current Sensors's CML is selected
            const sensorBelongsToSelectedCml = subjects
                .filter((x) => x.type === "Condition Monitoring Location" && x.corrosionLoopId === row.corrosionLoop)
                .some((cl) => cl.name === row.cmlId);


            //Disable the checkbox if a CML is selected and the current Sensor does not belong to any selected CML
            disableCheckbox = isCmlSelected && !sensorBelongsToSelectedCml;
        }

        return (
            <div className='cell-action' id="analysis-data-list-id-7">
                {site === 'BON' && <Checkbox
                    checked={isSelected}
                    size='xsmall'
                    disabled={disableCheckbox}
                    onChange={(e) => {
                        if (e.target.checked) {
                            handleAdd({
                                rowId: row.id,
                                corrosionLoopId: row.corrosionLoop,
                                subjects,
                                row: row.id,
                                type: "Sensor",
                                site: row.siteId,
                                shortname: row.name,
                                cmlId: row.cmlId,
                                updateSubjectsIndex,
                                updateSubjects,
                                subjectIndex,
                                analysisData
                            })

                        }
                        else {
                            handleClear({
                                subjects,
                                id: row.id,
                                type: "Sensor",
                                site: row.siteId,
                                updateSubjectsIndex,
                                updateSubjects
                            })
                        }
                    }}
                />}

                <Link id="analysis-data-list-id-8"
                    className={
                        row.uninstalled ? "link redContent" : "link blueContent"
                    }
                    to={`/home/${encodeURIComponent(row.id)}/details`}
                    title={
                        row.uninstalled
                            ? row.productionUnit === DE_INSTALLED_PROD_UNIT
                                ? DE_INSTALL_HELP.bukam
                                : DE_INSTALL_HELP.other
                            : ""
                    }
                >
                    {R.path(["isRealSensor"], row) && row.name ? row.name : 'No Sensor'}
                </Link>
            </div>
        );
    };

    /** @type import('@tanstack/react-table').ColumnDef<any> */
   
    const columns = [
        {
            header: 'Site',
            accessorFn: row => row.siteName,
            id: 'site',
        },
        {
            header: 'Prod Unit',
            accessorFn: row => row.productionUnit,
            id: 'productionUnit',
        },
        {
            header: 'Unit',
            accessorFn: row => row.unit,
            id: 'unit',
        },
        {
            header: 'Equipment',
            accessorFn: row => row.equipment,
            id: 'equipment',
        },
        {
            header: "Corrosion Loop",
            cell: (props) => {
                const row = props.row.original;
                return row.corrosionLoop ? <CorrosionLoopContent row={row} /> : null;
            },
            accessorFn: (row) => row.corrosionLoop,
            id: "corrosionLoop"
        },
        {
            header: "CML",
            cell: (props) => {
                const row = props.row.original;
                return row.cmlId ? <CMLContent row={row} /> : null;
            },
            accessorFn: (row) => row.cmlId,
            id: "cmlId"
        },
        {
            header: "Sensor",
            cell: (props) => {
                const row = props.row.original;
                return row ? <SensorContent row={row} /> : null;
            },
            accessorFn: (row) => row.id,
            id: "id"
        }
        ];

    return (
        <>
            {(!!error || (!loading && analysisData?.analysisList?.length === 0)) && <div className='empty-container' id="analysis-data-list-id-9">
                <Text id="analysis-data-list-id-10">No Sensors to display</Text>
            </div>}
            {analysisData?.analysisList?.length <= 0 && loading &&
                <div className='loading-container' id="analysis-data-list-id-11" role='status'><Loading id="analysis-data-list-id-12" /></div>}
            {analysisData?.analysisList?.length > 0 &&
                <DataTable data={analysisData.analysisList} columns={columns} count={analysisData.analysisCount}
                    currentPage={+sessionStorage.getItem("analysisPage") || INIT_PAGE}
                    handleCurrentPageChange={handleCurrentPageChange}
                    handleOrderChange={handleOrderChange}
                    INIT_ORDER={sessionStorage.getItem("analysisOrder") || INIT_ORDER}
                    INIT_ORDER_DIRECTION={+sessionStorage.getItem("analysisOrderDirection") || INIT_ORDER_DIRECTION}
                    loading={loading}
                    paginationMode='client'
                />
            }
        </>
    )
}

export default AnalysisDataList